import { useEffect, useState, useMemo } from "react";
import { PlusCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { Spin, Modal, Button, Dropdown } from "antd";
import TableComponent from "../../components/TableComponent";
import { createColumn } from "../../utils/tableUtils";
import { useNavigate } from "react-router-dom";
import { tableDateFormatter } from "../../utils/formatDate";
import MainButtonComponent from "../../components/MainButtonComponent";
import {
	HeaderComponent,
	Container,
	ContainerHeader,
	ActionButtonOverlay,
	WarningMessageBox,
} from "../../components/styled/common";
import { useDocCategoryContext } from "../../context/DocumentCategoryContext/DocumentCategoryContext";

const DocumentCategoryList = () => {
	const [tableData, setTableData] = useState<any[]>([]);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentItem, setCurrentItem] = useState<any>(null);
	const { docCategoryList, clearDocCategoryList, removeDocCategory, getDocCategoryList, operationStatus } = useDocCategoryContext();

	const navigate = useNavigate();

	useEffect(() => {
		clearDocCategoryList();
		getDocCategoryList();

		return () => {
			clearDocCategoryList();
		};
	}, []);

	useEffect(() => {
		setTableData(docCategoryList);
	}, [docCategoryList]);

	const columns = useMemo(() => [
		createColumn({
			title: "Sıra No",
			dataIndex: "categoryNo",
			width: 30,
			sorterType: "numeric",
		}),
		createColumn({
			title: "Kategori Adı",
			dataIndex: "categoryName",
			width: 100,
			sorterType: "string",
			render: (text, record) => (
				<button
					type="button"
					onClick={() => navigate(`/documents/${record.categoryId}`)}
					style={{ cursor: "pointer", color: "#1890ff", background: "none", border: "none", padding: 0, font: "inherit" }}
				>
					{record.categoryName}
				</button>
			)
		}),
		createColumn({
			title: "Url",
			dataIndex: "url",
			width: 200,
			sorterType: "string"
		}),
		createColumn({
			title: "Tarih",
			dataIndex: "creationDate",
			width: 50,
			sorterType: "string",
			render: (text) => tableDateFormatter(text, "DD.MM.YYYY"),
		}),
		createColumn({
			title: "",
			dataIndex: "action",
			width: 20,
			render: (text, record: any) => {
				const menuItems = [
					{
						key: "edit",
						label: "Güncelle",
						onClick: () => navigate(`/edit-doc-category/${record.categoryId}`),
					},
					{
						key: "delete",
						label: "Sil",
						onClick: () => {
							setCurrentItem(record);
							setIsModalVisible(true);
						},
					},
				];

				return (
					<Dropdown menu={{ items: menuItems }} trigger={["click"]}>
						<MoreOutlined />
					</Dropdown>
				);
			},
		}),
	], [navigate]);


	return (
		<div>
			<HeaderComponent>Kategoriler</HeaderComponent>
			<Container>
				<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
					<ContainerHeader>
						<ActionButtonOverlay>
							<MainButtonComponent
								style={{ marginRight: "15px" }}
								icon={<PlusCircleOutlined />}
								onClick={() => navigate("/add-doc-category")}
							>
								Yeni Ekle
							</MainButtonComponent>
						</ActionButtonOverlay>
					</ContainerHeader>
				</Spin>
				{!(operationStatus.type === "loading" && operationStatus.operation === "fetch") && (
					<TableComponent
						columns={columns}
						dataSource={tableData}
					/>
				)}
			</Container>
			<Modal
				title="Kategoriyi Sil"
				open={isModalVisible}
				centered
				onCancel={() => setIsModalVisible(false)}
				footer={[
					<Button key="back" type="text" onClick={() => setIsModalVisible(false)}>
						İptal
					</Button>,
					<Button
						loading={operationStatus.type === "loading" && operationStatus.operation === "delete"}
						key="submit"
						type="primary"
						danger
						onClick={async () => {
							await removeDocCategory(currentItem?.categoryId);
							setIsModalVisible(false);
						}}
					>
						Evet
					</Button>,
				]}
			>
				<p><strong>{`"${currentItem?.categoryName}"`}</strong> kategorisini silmek istediğinizden emin misiniz?</p>
				{currentItem?.hasDocuments && (
					<WarningMessageBox>
						Bu kategoriye ait dokümanlar bulunmaktadır. Silinmesi durumunda, içerisindeki tüm dokümanlar da silinecektir.
					</WarningMessageBox>
				)}
			</Modal>
		</div>
	);
};

export default DocumentCategoryList;
